import component from "./DuplicateScoresReport.js";

export default component;
